import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function PrivateRoute({ children }) {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!isAdmin) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ error: "Нет прав администратора" }}
      />
    );
  }

  return children;
}

export default PrivateRoute;
